export const workingHoursConstants = {
  WORKING_HOURS_REQUEST: 'CONTRACTOR_WORKING_HOURS_REQUEST',
  WORKING_HOURS_SUCCESS: 'CONTRACTOR_WORKING_HOURS_SUCCESS',
  WORKING_HOURS_FAILURE: 'CONTRACTOR_WORKING_HOURS_FAILURE',
};
